// @flow strict
// Copyright (C) 2021 Deep Skills Inc., - All Rights Reserved
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential


let _apiEndpoint = "";

export function apiEndpoint(): string {
  return _apiEndpoint;
}

export function setApiEndpoint(apiEndpoint: string) {
  _apiEndpoint = apiEndpoint;
}

